import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { LeadsListPage, parseLeadsSearch } from '@/features/marketing';

/** Leads — `/marketing/leads`. The filters live in the URL so the hub and the report can deep-link them. */
export const Route = createFileRoute('/_auth/$orgId/marketing/leads')({
  validateSearch: parseLeadsSearch,
  component: LeadsRoute,
});

function LeadsRoute() {
  const { orgId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = useNavigate({ from: '/$orgId/marketing/leads' });
  // Each filter change pushes a history entry, so Back undoes it.
  return <LeadsListPage orgId={orgId} search={search} onChangeSearch={(next) => void navigate({ search: next })} />;
}
